<div class="container">
    <div class="preeco-form" id="preeco-privacy-policy" data-type="privacy-policy"
        data-access-token="wTjInThrhRQ6n5KRdLDu8pt3t7pPqnRB9kzB8I0Zq74LhOPEZW9Esg9402akPucT" data-locale="de-DE">
    </div>
    <div class="buttons">
        <button [autofocus]="true" class="btn btn-default btn-ok" (click)="goToStep2()">Ok</button>
    </div>
</div>
